import { NgModule } from "@angular/core";
import { CertificateCrudModule } from "./../key/certificate/certificate.module";
import { PrivateKeyCrudModule } from "./../key/private-key/private-key.module";
import { SharedModule } from "../shared";
import { EndPointListComponent } from "./end-point-list.component";
import { EndPointRoutingModule } from "./end-point-routing.module";

const DIRECTIVES = [EndPointListComponent];

@NgModule({
	imports: [
		SharedModule,
		EndPointRoutingModule,
		PrivateKeyCrudModule,
		CertificateCrudModule,
	],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
})
export class EndPointModule {}
